import { render } from "./TeacherFooter.vue?vue&type=template&id=97ee2b9c&scoped=true"
import script from "./TeacherFooter.vue?vue&type=script&lang=js"
export * from "./TeacherFooter.vue?vue&type=script&lang=js"

import "./TeacherFooter.vue?vue&type=style&index=0&id=97ee2b9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97ee2b9c"]])

export default __exports__